/*
 * @format
 */

import * as actionTypes from '../action-types';

export const initialState = {
  pendingDsrCommands: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.LOGOUT_COMPLETED:
      return initialState;

    case actionTypes.PENDING_DSR_COMMANDS_RECEIVED:
      return {
        ...state,
        pendingDsrCommands: action.pendingDsrCommands,
      };

    case actionTypes.REMOVE_PENDING_DSR_COMMANDS:
      const pendingCommandId = action.pendingDsrCommand.id;
      const filteredPendingCommands = state.pendingDsrCommands.filter(
        command => command.id !== pendingCommandId,
      );

      return {
        ...state,
        pendingDsrCommands: filteredPendingCommands,
      };

    default:
      return state;
  }
};
